import { isEmpty } from 'lodash';

/**
 * Returns the validation message key to display.
 *
 * @param {string[]} errors - Message logging to display
 * @param {string[]} warnings - Message warning to display
 *
 * @returns {string}
 */
export const calculateValidationMessageKey = ({
    errors,
    warnings
}) => {
    if (!isEmpty(errors)) {
        return errors[0];
    }

    if (!isEmpty(warnings[0])) {
        return warnings[0];
    }
};
